import { DEFAULT_LOCATIONS, CHILDRENSTEXAS, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token d2b449ad09ed1bb8312b3112a179840dc0008292',
  staging: 'Token 9eb67b34b4bb58cbd5d9566ba16aa990867636c9',
  prod: 'Token 2b7960b775f6b2b2409648be65c65ab4a88a8b82',
};

const token = selectToken(apiTokens);

const childrensTexasConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'childrenstexas',

  API_TOKEN: token,
  EMBOLD_CLIENT: CHILDRENSTEXAS,

  // login
  SHOW_REGION_SELECTOR: false,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Dallas },
  LOGIN_NETWORK_NAME: 'childrensTexasUserId',

  // content
  DISPLAY_NAME: "Children's Health System of Texas",
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default childrensTexasConfig;
